import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Resizer from 'iframe-resizer/js/iframeResizer.contentWindow.min';
import './plugins/vuetify';
import './stylus/main.styl';
import VueTypedJs from 'vue-typed-js';
import App from './App.vue';
import router from './router';
import store from './store';
import filters from './filters';
import utils from './utils';

window.iFrameResizer = {
  targetOrigin: 'https://www.fanshield.com',
};

Vue.use(Resizer);
Vue.use(VueTypedJs);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_CORE_URL;

const isProduction = process.env.NODE_ENV === 'production';
/* eslint-disable */
const errorInterceptor = (error) => {
  // For normal API responses assign here
  const errorStatus = error.response.status;
  let pushMessage = error.response.statusText;
  // Sentry error tracking
  if (isProduction && errorStatus >= 400) {
    Sentry.captureMessage(new Error(JSON.stringify(error.response)), 'error');
  }

  // Respond to 500-level errors
  if (errorStatus >= 500) {
    app.$$response.formatServerError(error.response, pushMessage);
  }

  // Respond to 400-level errors
  if (errorStatus >= 400 && errorStatus < 500) {
    const [topError] = error.response.data.error.errors;
    pushMessage = topError.message;
  }

  if (pushMessage === 'Order token cannot be verified' || pushMessage === 'Order could not be found for the given token' || pushMessage === 'Not found.') {
    pushMessage = 'Session URL is not valid. Please only load this webpage directly from the email received. ';
  }

  const regex = /.non_field_errors - /gi;
  if (pushMessage.includes('.non_field_errors -')) {
    pushMessage = pushMessage.replace(regex, '');
  }

  // Fire off an event to show the alert at top level
  app.$store.dispatch('pushMessageAlert', { message: pushMessage });
  if ('parentIFrame' in window) {
    window.parentIFrame.sendMessage({ error: pushMessage });
  }
  return Promise.reject(error);
};

Vue.axios.interceptors.response.use(response => response, errorInterceptor);

// Registers helper util functions to prototype to make available to all Vue components.
Object.entries(utils).forEach(([key, value]) => {  Object.defineProperty(Vue.prototype, `$$${key}`, { value });
});

// Registers all filters under filter folder.
Object.keys(filters).forEach((helperFilter) => {
  Object.keys(filters[helperFilter]).forEach((functionName) => {
    Vue.filter(
      `${helperFilter}_${functionName}`,
      filters[helperFilter][functionName],
    );
  });
});

if (isProduction) {
  Sentry.init({
    dsn: 'https://8dec2a359e7c4e9d8cb184e57c5822e5@sentry.io/1440525',
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  });
}

const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
